import vn from '../languages/vn.js';
import us from '../languages/us.js';
var languages = {
	vn: vn,
	us: us,
}
export default languages;